/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { createSlice } from '@reduxjs/toolkit';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */

interface LoadingPayload {
  payload: boolean;
}

const forceLoadingSlice = createSlice({
  name: 'forceLoading',
  initialState: false,
  reducers: {
    forceLoading: (_, action: LoadingPayload) => action.payload,
  },
});

export const forceLoadingAction = forceLoadingSlice.actions;
export const forceLoadingReducer = forceLoadingSlice.reducer;
